import belter from 'belter';
// @ts-ignore
import zoid from '@krakenjs/zoid/dist/zoid.frameworks';
import {CLASS} from './enums';

export function containerTemplate({
  uid,
  frame,
  prerenderFrame,
  doc,
  props,
  event,
  dimensions: {width, height}
}: Record<any, any>): HTMLElement | undefined {
  if (!frame || !prerenderFrame) {
    return;
  }

  const div = doc.createElement('div');
  div.setAttribute('id', uid);
  const style = doc.createElement('style');
  if (props.cspNonce) {
    style.setAttribute('nonce', props.cspNonce);
  }

  style.appendChild(
    doc.createTextNode(`
      #${uid} {
          display: block;
          position: relative;
          width: ${width};
          height: ${height};
      }
      #${uid} > iframe {
          display: block;
          position: absolute;
          width: 100%;
          height: 100%;
          top: 0;
          left: 0;
          transition: all .2s ease-in-out;
      }
      #${uid} > iframe.${CLASS.INVISIBLE} {
          opacity: 0;
      }
      #${uid} > iframe.${CLASS.VISIBLE} {
          opacity: 1;
      }
    `)
  );

  frame.allowPaymentRequest = 'true';

  div.appendChild(frame);
  div.appendChild(prerenderFrame);
  div.appendChild(style);

  prerenderFrame.classList.add(CLASS.VISIBLE);
  frame.classList.add(CLASS.INVISIBLE);

  event.on(zoid.EVENT.RENDERED, () => {
    prerenderFrame.classList.remove(CLASS.VISIBLE);
    prerenderFrame.classList.add(CLASS.INVISIBLE);

    frame.classList.remove(CLASS.INVISIBLE);
    frame.classList.add(CLASS.VISIBLE);

    setTimeout(() => {
      belter.destroyElement(prerenderFrame);
    }, 1);
  });

  event.on(zoid.EVENT.RESIZE, ({width: newWidth, height: newHeight}: Record<any, any>) => {
    if (typeof newWidth === 'number') {
      div.style.width = belter.toCSS(newWidth);
    }

    if (typeof newHeight === 'number') {
      div.style.height = belter.toCSS(newHeight);
    }
  });

  return div;
}
